import FacetSearchCardComponent from '@/components/showcase-modules/facet-search-card/facet-search-card';
import MarkerCardComponent from '@/components/showcase/marker-card/marker-card';
import { markersAPI } from '@/providers/apis/markers/markers';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'showcase-facets',
    components: {
        'marker-card-panel': MarkerCardComponent,
        'marker-card': FacetSearchCardComponent,
    },
})
export default class ShowcaseFacets extends Vue {

    // --------------------------------------------------------------------
    // Properties

    public facetsList: any = [
        {
            name: 'K12',
            key: 'Math',
            markerItems: new Array(4).fill({}),
        },
        {
            name: 'K12IND',
            key: 'Maths',
            markerItems: new Array(2).fill({}),
        },
        {
            name: 'Skills Training',
            key: 'Math',
            markerItems: new Array(1).fill({}),
        },
    ];

    public isLoading: boolean = false;

    // --------------------------------------------------------------------
    // Actions

    public onShowDetail(marker: any) {
        this.$router.push(`/showcase-revamp/marker-detail?markerId=${marker.id}`);
    }

    // --------------------------------------------------------------------
    // Hooks

    private created() {
        this.searchMarkers();
    }

    // -----------------------------------------------------------------
    // Methods

    private searchMarkers() {
        this.isLoading = true;
        const params: any = {
          filters: {
           'txFramework.fwCode': 'TMA',
            'txSubject.txSubjectCode': 'K12.MA',
          },
          limit: 10,
          offset: 0,
        };
        markersAPI.searchMarkers(params).then((markerList) => {
          this.facetsList[0].markerItems = markerList;
          this.facetsList[1].markerItems = markerList.slice(0, 2);
          this.facetsList[2].markerItems = markerList.slice(0, 1);
          this.isLoading = false;
        });
    }
}
